import React from 'react';
import './NavContainer.css';
import {Nav, Navbar} from 'react-bootstrap';
import { Link } from 'react-router-dom';


const NavContainer = () => {
    return (
        <div className="navbar-style">
            <Navbar collapseOnSelect expand="lg md" variant="dark" style={{ background:'#0085FF', padding:' 0 4rem'}}>

                <Navbar.Brand href="/home"><Link to="/home"><img src='https://i.ibb.co/HBZwH3N/NS-logo.png' alt="" style={{width:"80px", height:'auto'}}/></Link></Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    
                    <Nav className="ml-auto navStyle" style={{justifyContent: 'flex-end'}}>
                        <Link to="/home" className="navLink">Home</Link>
                        <Link to="/skills" className="navLink">Skills</Link>
                        <Link to="/projects" className="navLink">Projects</Link>
                        <Link to="/blogs" className="navLink ">Blogs</Link>
                        <Link to="/contact" className="navLink">Contact</Link>
                        <a href="https://drive.google.com/file/d/1MInbYT_Ol9uK16KeFv4CuhzJ7DxRW3ZV/view?usp=sharing" className="navLink" target="_blank" rel="noreferrer noopener">Download CV</a>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </div>
    );
};

export default NavContainer;